import { render, staticRenderFns } from "./invoicesubmissionmanagementtable.vue?vue&type=template&id=8f233d7e&scoped=true&"
import script from "./invoicesubmissionmanagementtable.vue?vue&type=script&lang=js&"
export * from "./invoicesubmissionmanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./invoicesubmissionmanagementtable.vue?vue&type=style&index=0&id=8f233d7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f233d7e",
  null
  
)

export default component.exports